const IMAGES = {
    kuwaitinput: require('./kuwaitinput.svg').default,
    enabill: require('./enabill.svg').default,
    union: require('./union2.svg').default,
    newsPaper: require('./newsPaper.svg').default,
    giftPaper: require('./gift2.svg').default,
    dialpad: require('./Dialpad2.svg').default,
    time: require('./time2.svg').default,
    enabillLogo: require('./EventEnabill.svg').default,
    enabillJan: require('./enabillJan.svg').default,
    paidInvoice: require('./paidInvoice.svg').default,
    pendingInvoice: require('./pendingInvoice.svg').default,
    cancelledInvoice: require('./cancelledInvoice.svg').default,
    forwardArrow: require('./forwardArrow.svg').default,
    smallKnet: require('./smallKnet.svg').default,
    smallCredit: require('./smallCredit.svg').default,
    smallApple: require('./smallApple.svg').default,
    smallPending: require('./smallPending.svg').default,
    smallCash: require('./smallCash.svg').default,
    leftArr: require('./leftfeb6.svg').default,
    money: require('./money.svg').default,
    searchtype: require('./searchtype.svg').default,
    InvoiceIcon: require('./InvoiceIcon.svg').default,
    inStore: require('./instore.png').default,
    inStorelt: require('./instorelt.png'),
    sunmilogo: require('./sunmilogo.svg')

    

    






}

export default IMAGES;

